import { STOP_LOADING } from '../actions/types';
import store from '../store';
import { PAIDIT_API } from '../config';

export default ({ data, request }) => {
    store.dispatch({ type: STOP_LOADING, payload: request.responseURL.split(PAIDIT_API)[1] });

    process.env.NODE_ENV === 'development' && console.log('Paidit server request success:', data);
    return data;
};
